import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, formatApiErrorDetail } from "../api";
import { useAuth } from "../AuthContext";
import Logo from "../components/Logo";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function AdminLogin() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#16181D] px-4">
      <div className="w-full max-w-sm rounded-2xl border border-[#2D323E] bg-[#1E2128] p-8">
        <div className="mb-8 flex justify-center">
          <Logo />
        </div>
        <h1 className="mb-1 text-center font-heading text-xl font-bold">Panel de administración</h1>
        <p className="mb-7 text-center text-sm text-[#8A8F98]">Acceso privado de NubeVape España</p>

        <form onSubmit={onSubmit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <Label htmlFor="login-email" className="text-[#8A8F98]">Email</Label>
            <Input
              id="login-email"
              data-testid="admin-login-email-input"
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 border-[#2D323E] bg-[#16181D] text-[#F2F4F6]"
              placeholder="tu@email.com"
            />
          </div>
          <div>
            <Label htmlFor="login-password" className="text-[#8A8F98]">Contraseña</Label>
            <Input
              id="login-password"
              data-testid="admin-login-password-input"
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 border-[#2D323E] bg-[#16181D] text-[#F2F4F6]"
              placeholder="••••••••"
            />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="rounded-lg border border-[#EF4444]/40 bg-[#EF4444]/10 px-3 py-2 text-sm text-[#EF4444]">
              {error}
            </p>
          )}
          <button
            type="submit"
            data-testid="admin-login-submit-btn"
            disabled={loading}
            className="w-full rounded-xl bg-gradient-to-r from-[#2EE6D6] to-[#7C5CFF] py-3 font-bold text-black transition-opacity hover:opacity-90 disabled:opacity-50"
          >
            {loading ? "Entrando…" : "Entrar"}
          </button>
        </form>

        <div className="mt-6 flex flex-col items-center gap-3 text-sm">
          <Link to="/forgot-password" data-testid="forgot-password-link" className="text-[#8A8F98] transition-colors hover:text-[#2EE6D6]">
            ¿Has olvidado la contraseña?
          </Link>
          <Link to="/" data-testid="back-to-store-link" className="flex items-center gap-1.5 text-[#8A8F98] transition-colors hover:text-[#F2F4F6]">
            <ArrowLeft className="h-4 w-4" /> Volver a la tienda
          </Link>
        </div>
      </div>
    </div>
  );
}
